import A, { ANCHORTARGETS, SPAN } from '../../../DOM/a/A.js';
import SVG from '../../../DOM/svg/SVG.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { span } from '../../../DOM/span/SPAN.js';
import ICON from '../../../SVG/icon/ICON.js';
import { ANCHORREL } from '../../../../enums/ANCHORREL.js';
// Model Structure
export const anchorAttr = makeAttrStruct([
    ['href', ''],
    ['target', ANCHORTARGETS.SELF],
    ['rel', ANCHORREL.NONE]
]);
export const anchorData = makeDataStruct([
    ['text', ''],
    ['icon']
]);
export const anchorModel = makeStruct([
    ['attributes', anchorAttr],
    ['data', anchorData]
]);
export function anchor(href, text, icon, target, rel) {
    return {
        attributes: anchorAttr(href, target, rel),
        data: anchorData(text, icon)
    };
}
/** A hyperlink / page anchor */
export default class ANCHOR extends A {
    constructor(node, model) {
        super(node, model);
        this.icon = new ICON(this, model.data.icon);
        this.text = new SPAN(this, span(model.data.text));
    }
}
export { A, SPAN, SVG };
